import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Car, Info } from "lucide-react";
import { SectionHeading } from "./SectionHeading";

export const Pricing = ({ onBook }) => {
  const navigate = useNavigate();
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="relative z-10 py-24 md:py-32 bg-[#0a0a0a] border-y border-white/5"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <SectionHeading
          overline="Pricing"
          title="Transparent, tailored to your vehicle"
          align="center"
        />
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-3xl border border-white/10 bg-[#111111] p-10 md:p-14 text-center"
        >
          <div className="mx-auto h-14 w-14 rounded-full bg-white/10 flex items-center justify-center mb-7">
            <Car size={26} className="text-white" />
          </div>
          <p className="font-heading text-2xl md:text-3xl font-semibold tracking-tight text-white max-w-2xl mx-auto leading-snug">
            Prices may vary depending on vehicle size and condition.
          </p>
          <div className="mt-6 flex items-center justify-center gap-2 text-zinc-400">
            <Info size={15} />
            <p className="text-sm">
              Reach out for a fast, personalized quote — no obligations.
            </p>
          </div>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              data-testid="pricing-quote-btn"
              onClick={onBook}
              className="btn-3d gloss-sweep inline-flex items-center rounded-full bg-[#fafafa] text-[#050505] font-semibold px-8 py-4 hover:bg-white"
            >
              Book on Booksy
            </button>
            <button
              data-testid="pricing-membership-btn"
              onClick={() => { navigate("/memberships"); window.scrollTo({ top: 0 }); }}
              className="btn-3d-outline inline-flex items-center rounded-full border border-white/20 text-white font-medium px-8 py-4 hover:bg-white/5"
            >
              View Maintenance Plans
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
